<template>
  <div v-bind:class="{'spinner-is-visible': isSpinnerVisible }">
    <div v-bind:class="['entity-details', {'hidden': !isLoaded }]">
      <section>
        <header>
          <div>
            <DamageRating
              :rating="asset.rating" 
            />
          </div>
          <div>
            {{asset.title}}
            <div v-if="asset.nearestAddress" class="note">{{asset.nearestAddress}}</div>
          </div>
        </header>
        <div class="entity-detail form-group">
          <label class="placeholder placeholder-static">GPS Location</label>
          {{asset.latitude}}, {{asset.longitude}}
        </div>
        <div v-if="asset.poleNumber" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Pole Number</label>
          {{ asset.poleNumber }}
        </div>
        <div v-if="asset.poleNumber" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Facility ID</label>
          {{ asset.facilityID }}
        </div>
        <div v-if="asset.manufacturer" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Manufacturer</label>
          {{ asset.manufacturer }}
        </div>
        <div v-if="asset.windZone" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Species</label>
          {{asset.species}}
        </div>
        <div v-if="asset.class" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Class</label>
          {{ asset.class }}
        </div>
        <div v-if="asset.length" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Length</label>
          {{ asset.length }}
        </div>
        <div v-if="asset.year" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Year</label>
          {{ asset.year }}
        </div>
        <div v-if="asset.inspectionDate" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Last activity</label>
          {{ h$.formatDate.short(asset.inspectionDate) }}
        </div>
        <div v-if="asset.inspectionType" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Activity Type</label>
          {{ asset.inspectionType }}
        </div>
        <div v-if="asset.damagedecayPresent" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Damage/Decay Present</label>
          {{ asset.damagedecayPresent }}
        </div>
        <div v-if="asset.padInspectionType" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Pad Inspection Type</label>
          {{ asset.padInspectionType }}
        </div>
        <div v-if="asset.cabinetCorrosion" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Cabinet Corrosion</label>
          {{ asset.cabinetCorrosion }}
        </div>
        <div v-if="asset.cabinetDent" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Cabinet Dent</label>
          {{ asset.cabinetDent }}
        </div>
        <div v-if="asset.cabinetErosion" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Cabinet Erosion</label>
          {{ asset.cabinetErosion }}
        </div>
        <div v-if="asset.cabinetLeakingOil" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Cabinet Leaking Oil</label>
          {{ asset.cabinetLeakingOil }}
        </div>
        <div v-if="asset.padPadIssues" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Pad Issues</label>
          {{ detailFormat(asset.padPadIssues) }}
        </div>
        <div v-if="asset.padPadIssuesHoleSize" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Hole Size</label>
          {{ asset.padPadIssuesHoleSize }}
        </div>
        <div v-if="asset.padPadIssuesNumberOfHoles" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Number of Holes</label>
          {{ asset.padPadIssuesNumberOfHoles }}
        </div>
        <div v-if="asset.padmountIssues" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Padmount Issues</label>
          {{ asset.padmountIssues }}
        </div>
        <div v-if="asset.groundMountedEquipmentType" class="entity-detail form-group">
          <label class="placeholder placeholder-static">Ground Mounted Equipment Type</label>
          {{ asset.groundMountedEquipmentType }}
        </div>
      </section>
      <section 
        v-if="asset.hasPhotos"
      >
        <header>
          <div><h3>Photos</h3></div>
        </header>
        <div class="photo-gallery" style="min-height: 50px;">
          <photos
            ref="photos"
            :photos="photos"
            :gallery="asset.recordID"
            :user-can-update="false"
          ></photos>
        </div>
      </section>
      <section v-if="asset.maintenanceIssues && asset.maintenanceIssues.length > 0">
        <header>
          <div><h3>Maintenance Issues</h3></div>
        </header>
        <div
          class="entity-detail form-group"
          v-for="(value, key) in objectFromString(asset.maintenanceIssues)"
          :key="key"
        >
          <label class='placeholder placeholder-static'>{{key}}</label>
          {{ detailFormat(value) }}
        </div>
      </section>
      <section v-if="asset.commentSummary">
        <header>
          <div><h3>Comment Summary</h3></div>
        </header>
        <div class="entity-detail form-group">
          <div class="note"
            v-for="(value, key) in objectFromString(asset.commentSummary)"
            :key="key"
          >
            <strong>{{ key }}:</strong> <span>{{ detailFormat(value) }}</span>
          </div>
        </div>
      </section>
    </div>
    <div class="spinner"></div>
  </div>
</template>

<script>
import DamageRating from "../shared/damage_rating";
import Photos from "../shared/details/photos";

import helpers from "../../helpers.js";

import EntityDetails from "../shared/details/entity_details"; 

export default {
  extends: EntityDetails,

  components: {
    DamageRating,
    Photos
  },

  props: {
    args: Object
  },

  data() {
    return {
      asset: {},
      photos: []
    }
  },

  setup () {
    return {
      h$: helpers
    }
  },

  watch: {
    args: {
      immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal || newVal.length == 0) return;

        this.asset = newVal;

        if (this.asset.fulcrumRecordID && vmFulcrumAppDashboard && vmFulcrumAppDashboard.$refs.fulcrumAppDashboard.$refs.dataView) {
          vmFulcrumAppDashboard.$refs.fulcrumAppDashboard.$refs.dataView.$refs.assetsGrid.markRow(this.asset.fulcrumRecordID);
        }

        if (this.asset.hasPhotos) {
          this.fetchPhotos();
        }
      }
    }
  },

  mounted: function() {
    this.isLoaded = true;

    setTimeout(() => {
      this.isSpinnerVisible = false;
    }, 500);
  },

  beforeUnmount: function() {
    if (vmFulcrumAppDashboard && vmFulcrumAppDashboard.$refs.fulcrumAppDashboard.$refs.dataView) {
      vmFulcrumAppDashboard.$refs.fulcrumAppDashboard.$refs.dataView.$refs.assetsGrid.unmarkRows()
    }
  },

  computed: {

  },

  methods: {
    fetchPhotos: function() {
      this.isSpinnerVisible = true;

      app.graphql.get(
        "dashboard.fulcrum.assetPhotos",

        {
          recordID: this.asset.recordID
        },

        (data) => {
          this.isLoaded = true

          this.photos = data.data.fulcrumPhotos.edges.map(edge => { 
            let photo = edge.node;

            photo.id = photo.photoId;

            return photo;
          });

          setTimeout(() => {
            this.isSpinnerVisible = false
          }, 500)
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title : "Asset Photos",
            message : "Something went wrong! Asset Photos cannot be found or doesn't exist!"
          })
        }
      );
    },

    objectFromString: function(issuesText) {
      const issues = {};

      if (!issuesText) return issues;

      // Split input into parts. Accept newlines, '||' and single '|' as separators.
      const parts = String(issuesText).split(/\r?\n|\s*\|\|\s*|\s*\|\s*/);

      parts.forEach(part => {
        const trimmed = String(part || '').trim();
        if (!trimmed) return;

        // Expect 'Key: Value' structure. Split on first ':'
        const idx = trimmed.indexOf(':');
        if (idx === -1) return; // skip malformed

        const key = trimmed.slice(0, idx).trim();
        const valueRaw = trimmed.slice(idx + 1).trim();

        // value may be comma-separated; normalize spacing
        const values = valueRaw.split(',').map(v => v.trim()).filter(v => v.length > 0);

        if (!issues[key]) {
          issues[key] = [];
        }

        // Append values preserving order and avoiding duplicates
        values.forEach(v => {
          if (!issues[key].includes(v)) issues[key].push(v);
        });
      });

      return issues;
    },

    detailFormat: function(value) {
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      
      if (/(\d{4}-\d{2}-\d{2})/.test(value)) {
        return this.h$.formatDate.short(value);
      }

      return value;
    },
  }
}
</script>
